import Dropdown from '@anm/components/Dropdown';
import { FC } from 'react';

import withUser, { WithUserProps } from '../../../../HOCs/withUser';
import UserAvatar from '../../../UserAvatar';
import UserMenuLinkList from '../../../user/UserMenuLinkList';

import StudioDisplayName from './Wrapper';

export type UserMenuProps = WithUserProps & {};

export type MenuLinkItem = {
  link: string;
  title: string;
};

const UserMenu: FC<UserMenuProps> = ({ user: { profile } }) => (
  <Dropdown direction="to-bottom-right" openerVariant="black" renderContent={() => <UserMenuLinkList />}>
    <UserAvatar />
    <StudioDisplayName title={profile!.displayName}>{profile!.displayName}</StudioDisplayName>
  </Dropdown>
);
export default withUser(UserMenu);
